const coPilotToggleBtn = document.getElementById('coPilotToggleBtn');
const coPilotPanelCloseBtn = document.getElementById('coPilotPanelCloseBtn');
const coPilotPanel = document.getElementById('coPilotPanel');
const copilotHost = document.getElementById('coPilotHost');

function ensureCopilotIframe() {
    const existing = document.getElementById('copilot-chat');
    if (existing) {
        return existing;
    }

    if (!copilotHost) {
        return null;
    }

    const src = copilotHost.getAttribute('data-copilot-src');
    if (!src) {
        return null;
    }

    const iframe = document.createElement('iframe');
    iframe.id = 'copilot-chat';
    iframe.src = src;
    iframe.setAttribute('frameborder', '0');
    iframe.style.width = '100%';
    iframe.style.height = '100%';

    copilotHost.appendChild(iframe);
    return iframe;
}

function openCoPilotPanel() {
    ensureCopilotIframe();
    coPilotPanel.classList.remove('translate-x-full');
    coPilotToggleBtn.classList.add('hidden');
}

function closeCoPilotPanel() {
    coPilotPanel.classList.add('translate-x-full');
    coPilotToggleBtn.classList.remove('hidden');
}

function resetCopilotChat() {
    const iframe = document.getElementById('copilot-chat');
    if (!iframe) {
        return;
    }

    const url = new URL(iframe.src);
    url.searchParams.set('reset', String(Date.now()));
    iframe.src = url.toString();
}

if (coPilotToggleBtn) {
    coPilotToggleBtn.addEventListener('click', openCoPilotPanel);
}

if (coPilotPanelCloseBtn) {
    coPilotPanelCloseBtn.addEventListener('click', closeCoPilotPanel);
}

document.addEventListener('click', e => {
    if (!coPilotPanel.contains(e.target) && !coPilotToggleBtn.contains(e.target)) {
        closeCoPilotPanel();
    }
});